import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Navigate, Outlet } from 'react-router-dom';

import { FullPageSpinner } from '../components/ui/Spinner.js';

/** Guards child routes: shows a loader during interaction, redirects to /login when signed out. */
export function ProtectedRoute(): JSX.Element {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();

  if (inProgress !== InteractionStatus.None && !isAuthenticated) {
    return <FullPageSpinner label="Signing in…" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
